export default __webpack_public_path__ + "static/media/icon_edit.0d3cfd8c.svg";